// Image optimization helper
// Converts images to WebP format via wsrv.nl proxy for better performance

export const optimizeImage = (url, options = {}) => {
  const { width, quality = 80 } = options;
  
  // Encode the original URL
  const encodedUrl = encodeURIComponent(url);
  
  // Build wsrv.nl URL with WebP output
  let optimizedUrl = `https://wsrv.nl/?url=${encodedUrl}&output=webp&q=${quality}`;
  
  // Add width if specified
  if (width) {
    optimizedUrl += `&w=${width}`;
  }
  
  return optimizedUrl;
};

// Pre-defined image sizes for common use cases
export const imageUrls = {
  hero: (url) => optimizeImage(url, { width: 1920, quality: 85 }),
  large: (url) => optimizeImage(url, { width: 1200, quality: 80 }),
  medium: (url) => optimizeImage(url, { width: 800, quality: 80 }),
  thumbnail: (url) => optimizeImage(url, { width: 400, quality: 75 }),
};
